import * as services from '../services';

export default {
  namespace: 'dvm',

  state: {
    fieldList: [],
    approvalList: [],
    searchValue: {},
  },

  effects: {
    //查询决策图版本审计
    *getDiagramVersionList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        services.getDiagramVersionList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          fieldList: response.length > 0 ? response : [],
        },
      });
    },
    //查询版本信息列表
    *getApprovalList({}, { call, put }) {
      const { data: response } = yield call(services.getApprovalList);
      yield put({
        type: 'save',
        payload: {
          approvalList: response || [],
        },
      });
    },
    //版本回滚
    *rollBack({ payload: { values }, callback }, { call }) {
      const { data: response } = yield call(services.rollBack, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //申请发布
    *applyForRelease({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(services.applyForRelease, id);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //设置为当前版本
    *setToCurrentVersion({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(services.setToCurrentVersion, id);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 决策图版本管理编辑
    *updateDiagramVersionAudit(
      { payload: { id, values }, callback },
      { call },
    ) {
      const { data: response } = yield call(
        services.updateDiagramVersionAudit,
        id,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 获取基础版本下拉数据
    *queryDiagramVersion({ payload: {}, callback }, { call }) {
      const { data: response } = yield call(services.queryDiagramVersion);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 获取基础版本下拉数据
    *addDiagramVersion({ payload: { values }, callback }, { call }) {
      const { data: response } = yield call(services.addDiagramVersion, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 查询版本list
    *getVersion({ payload: { values }, callback }, { call }) {
      const { data: response } = yield call(services.getVersion, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
